import React from 'react';
//import logo from './logo.svg';
//import logo from './images/LogoBusinessReportsTrans.png';
import './App.css';
import { SidebarWithMenu } from './csi_components/sideBarMenu/sideBarMenu';
import logoFooter from './images/LogoBusinessReportTransWhiteLong.png'


function App() {
 
  return (
    <div className="App">
      {/* <header className="App-header">
           <a title="CSI Business Services" href="http://www.csibs.com.co" target="_blank" rel="noopener noreferrer"><img src={logo} className="App-logo" alt="CSI Business Services"/></a>
      </header> */}
      <div className="App-body">
      
          <SidebarWithMenu/>

      </div>

      <footer className="App-footer">
          <a className="e_footer_link" title="CSI Business Services" href="http://www.csibs.com.co" target="_blank" rel="noopener noreferrer"><img src={logoFooter} className="App-logo-footer" alt="logoFooter" /></a>
      </footer>
     </div> 
  );
}

export default App;
